import React, { useState, useEffect } from "react";
import axios from 'axios';
import { HiMiniUserGroup } from "react-icons/hi2";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import { MdOutlinePerson4 } from "react-icons/md";
import { BsPersonFillExclamation } from "react-icons/bs";
import { FaBell } from "react-icons/fa6";
import * as XLSX from "xlsx";
function ManageUser() {
  const [users, setUSers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [expandedUserId, setExpandedUserId] = useState(null);
  const [totalCoins, setTotalCoins] = useState(0);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [selectedUserForEmp, setSelectedUserForEmp] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false);
  const [walletUsed, setWalletUsed] = useState(0);
  const [remainingWallet, setRemainingWallet] = useState(0);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [selectedNotifyUser, setSelectedNotifyUser] = useState(null);
  const [notifyMessage, setNotifyMessage] = useState("");
  const [subHistory, setSubHistory] = useState([]);
  // const [selectedUser, setSelectedUser] = useState(null);
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const handleViewClick = user => {
    setSelectedUser(user);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
    setSelectedUser(null);
  };
  const fetchUser = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-users");

      // const filteredUsers = res.data.filter(user => user.id !== 1);
      const filteredUsers = res.data.filter(user => user.id !== 1).sort((a, b) => b.id - a.id);
      setUSers(filteredUsers);
    } catch (error) {
      console.log(error);
    }
  };
  const handleViewEmployees = async user => {
    try {
      setSelectedUserForEmp(user);
      const res = await axios.get(`https://api.sweepydo.in/fetch-referal/${user.user_id}`);
      const list = res.data;
      setEmployeeList(list);
      const totalCoins = list.reduce((sum, item) => sum + Number(item.coins || 0), 0);
      setTotalCoins(totalCoins);
      setShowEmployeeModal(true);
      const userId = user.id;
      const userSubs = subHistory.filter(s => Number(s.user_id) === Number(userId));
      const walletUsed = userSubs.filter(s => s.payment_mode?.toLowerCase() === "wallet").reduce((sum, s) => sum + Number(s.coins || 0), 0);
      const remaining = totalCoins - walletUsed;
      setWalletUsed(walletUsed);
      setRemainingWallet(remaining);
    } catch (err) {
      console.log(err);
    }
  };
  const fetchSubHistory = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-subscription-history`);
      setSubHistory(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleToggleStatus = async id => {
    try {
      await axios.put(`https://api.sweepydo.in/update-user-status/${id}`);
      showToast("Status updated successfully!", "success");
      fetchUser();
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "danger");
    }
  };
  useEffect(() => {
    fetchUser();
    fetchSubHistory();
  }, []);
  const filteredData = Array.isArray(users) ? users.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  const formatDate = date => {
    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  };
  const getAddress = address => {
    try {
      const parsed = JSON.parse(address);
      if (!parsed) return "-";
      const {
        name,
        subLocality,
        locality,
        state,
        country,
        pincode
      } = parsed;
      return [name, subLocality, locality, state, country, pincode].filter(Boolean).join(", ");
    } catch {
      return "-";
    }
  };
  const handleUserNotification = async () => {
    if (!notifyMessage.trim()) {
      showToast("Please enter notification message", "warning");
      return;
    }
    try {
      const response = await axios.post("https://api.sweepydo.in/user-notification", {
        user_id: selectedNotifyUser.id,
        message: notifyMessage
      });
      showToast(response.data.message || "Notification Sent", "success");
      setNotifyMessage("");
      setShowNotifyModal(false);
    } catch (error) {
      console.error(error);
      showToast(error.response?.data?.message || "Server Error", "danger");
    }
  };

  // const downloadUsersExcel = async () => {
  //   try {
  // Configuration details withheld; supply approved runtime settings. 

  //     const users = res.data
  //       .filter((user) => user.id !== 1)
  //       .sort((a, b) => b.id - a.id);

  //     const worksheet = XLSX.utils.json_to_sheet(users);

  //     const workbook = XLSX.utils.book_new();

  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

  //     XLSX.writeFile(workbook, "users.xlsx");

  //   } catch (error) {
  //     console.error("Error downloading users:", error);
  //   }
  // };

  // const handleSearch = async () => {
  //   console.log('search function');
  //   try {
  //     const params = new URLSearchParams();

  //     if (searchTerm.trim()) {
  //       params.append("search", searchTerm.trim());
  //     }

  //     if (fromDate) {
  //       params.append("fromDate", fromDate);
  //     }

  //     if (toDate) {
  //       params.append("toDate", toDate);
  //     }

  //     console.log(params);

  //     const response = await fetch(
  // Configuration details withheld; supply approved runtime settings. 
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to fetch users");
  //     }

  //     const data = await response.json();

  //     console.log(data.length)

  //     setUSers(data.users || data);

  //   } catch (error) {
  //     console.error("Fetch users error:", error);
  //   }
  // };

  const downloadUsersExcel = async () => {
    try {
      const params = new URLSearchParams();

      // Search filter
      if (searchTerm.trim()) {
        params.append("search", searchTerm.trim());
      }

      // From date
      if (fromDate) {
        params.append("fromDate", fromDate);
      }

      // To date
      if (toDate) {
        params.append("toDate", toDate);
      }
      const res = await axios.get(`https://api.sweepydo.in/fetch-users?${params.toString()}`);
      const users = (res.data.users || res.data).filter(user => user.id !== 1).sort((a, b) => b.id - a.id);
      if (users.length === 0) {
        showToast("No users found for selected filters", "warning");
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(users);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
      XLSX.writeFile(workbook, "users.xlsx");
      showToast(`${users.length} users downloaded successfully`, "success");
    } catch (error) {
      console.error("Error downloading users:", error);
      showToast("Failed to download users", "danger");
    }
  };
  const handleSearch = async () => {
    try {
      const params = new URLSearchParams();

      // Search text
      if (searchTerm.trim()) {
        params.append("search", searchTerm.trim());
      }

      // From date
      if (fromDate) {
        const formattedFromDate = new Date(fromDate).toISOString().split("T")[0];
        params.append("fromDate", formattedFromDate);
      }

      // To date
      if (toDate) {
        const formattedToDate = new Date(toDate).toISOString().split("T")[0];
        params.append("toDate", formattedToDate);
      }
      const response = await fetch(`https://api.sweepydo.in/fetch-users?${params.toString()}`);
      if (!response.ok) {
        throw new Error("Failed to fetch users");
      }
      const data = await response.json();
      setUSers(data.users || data);
    } catch (error) {
      console.error("Fetch users error:", error);
    }
  };
  return <div className="container-fluid mt-3" style={{
    minHeight: "100vh"
  }}>
      <h2 className="mb-4 text-white text-center">User List</h2>


      <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />

      <div className="card shadow-lg border-0 p-3" style={{
      background: "var(--black)",
      borderRadius: "12px"
    }}>

        <div style={{
        background: "var(--black)",
        borderRadius: "12px",
        padding: "15px"
      }}>


          {/* <div className="card-header  d-flex justify-content-between align-items-center flex-wrap gap-2 py-4">
              <input
              type="text"
              className="form-control w-auto p-2"
              placeholder="Search by name ,number..."
              style={{
                background: "#1e293b",
                color: "#fff",
                border: "1px solid #334155",
                minWidth: "250px"
              }}
                value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div style={{ minWidth: "180px" }}>
           <label className="form-label text-white">From Date</label>
           <input
           type="date"
           className="form-control"
           value={fromDate}
           onChange={(e) => setFromDate(e.target.value)}
           style={{
           backgroundColor: "var(--black2)",
           color: "#fff",
           border: "1px solid #444"
           }}
           />
           </div>
           <div style={{ minWidth: "180px" }}>
           <label className="form-label text-white">To Date</label>
           <input
           type="date"
           className="form-control"
           value={toDate}
           onChange={(e) => setToDate(e.target.value)}
           style={{
           backgroundColor: "var(--black2)",
           color: "#fff",
           border: "1px solid #444"
           }}
           />
           </div>
                    <div className="d-flex gap-2">
              <button className="btn btn-info" 
               onClick={downloadUsersExcel}
              >Download Excel </button>
            </div>
           </div> */}


<div className="card-header d-flex justify-content-between align-items-end flex-wrap gap-3 py-4">

  <div>
    <input type="text" className="form-control p-2" placeholder="Search by name, number..." style={{
              background: "#1e293b",
              color: "#fff",
              border: "1px solid #334155",
              minWidth: "280px"
            }} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
  </div>

  <div className="d-flex align-items-end flex-wrap gap-2">

  
    <div style={{
              minWidth: "170px"
            }}>
      <label className="form-label text-white mb-1">
        From Date
      </label>

      <input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} style={{
                backgroundColor: "var(--black2)",
                color: "#fff",
                border: "1px solid #444"
              }} />
    </div>

    <div style={{
              minWidth: "170px"
            }}>
      <label className="form-label text-white mb-1">
        To Date
      </label>

      <input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} style={{
                backgroundColor: "var(--black2)",
                color: "#fff",
                border: "1px solid #444"
              }} />
    </div>

    <button type="button" className="btn btn-primary" onClick={handleSearch}>
      <i className="fa-solid fa-magnifying-glass me-2"></i>
      Search
    </button>


    {/* DOWNLOAD EXCEL */}
    <button type="button" className="btn btn-info" onClick={downloadUsersExcel}>
      <i className="fa-solid fa-file-excel me-2"></i>
      Download Excel
    </button>

  </div>

</div>


          <div className="table-responsive">
            <table className="text-center" style={{
            width: "100%",
            borderCollapse: "collapse",
            color: "#fff"
          }}>

              <thead>
                <tr style={{
                backgroundColor: "var(--black2)"
              }}>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SN</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>NAME</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>MOBILE</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>EMAIL</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>PASS</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>USER ID</th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ACTIONS</th>
                </tr>
              </thead>

              <tbody>

                {filteredData.map((s, idx) => <React.Fragment key={s.id}>
                    <tr style={{
                  backgroundColor: "var(--black)",
                  borderBottom: "1px solid rgba(255,255,255,0.06)",
                  transition: "0.3s"
                }} onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = "var(--black2)";
                }} onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = "var(--black)";
                }}>
                      <td style={{
                    padding: "18px",
                    textAlign: "center",
                    verticalAlign: "middle"
                  }}>{filteredData.length - idx}</td>
                      <td style={{
                    padding: "18px",
                    textAlign: "center"
                  }}>{s.name}</td>
                      <td style={{
                    padding: "18px",
                    textAlign: "center"
                  }}>{s.mobile}</td>
                      <td style={{
                    padding: "18px",
                    textAlign: "center"
                  }}>{s.email}</td>
                      <td style={{
                    padding: "18px",
                    textAlign: "center"
                  }}>{s.pass}</td>
                      <td style={{
                    padding: "18px",
                    textAlign: "center"
                  }}>{s.user_id}</td>
                      <td style={{
                    padding: "18px",
                    textAlign: "center"
                  }}>
                      

                        <div className="dropdown d-flex justify-content-center ">

                          <button className="btn btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{
                        background: "transparent",
                        border: "none",
                        color: "white",
                        fontSize: "18px"
                      }}>
                            ⋮
                          </button>

                          <ul className="dropdown-menu " style={{
                        backgroundColor: "var(--black2)",
                        border: "1px solid rgba(255,255,255,0.08)"
                      }}>

                            <li>
                              <button className="dropdown-item" type="button" style={{
                            color: "#fff",
                            backgroundColor: "transparent"
                          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = "var(--black)"} onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"} onClick={() => {
                            setSelectedUser(s);
                            setShowUserModal(true);
                          }}>
                                View User Detail
                              </button>
                            </li>

                            <li>
                              <button className="dropdown-item" type="button" style={{
                            color: "#fff"
                          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = "var(--black)"} onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"} onClick={() => handleViewEmployees(s)}>
                                Referral
                              </button>
                            </li>

                            <li>
                              <button className="dropdown-item" type="button" style={{
                            color: "#fff"
                          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = "var(--black)"} onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"} onClick={() => {
                            setSelectedStaff(s);
                            setShowStatusModal(true);
                          }}>
                                {s.is_active == 0 ? "Activate Staff" : "Deactivate Staff"}
                              </button>
                            </li>

                            <li>
                              <button className="dropdown-item" type="button" style={{
                            color: "#fff"
                          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = "var(--black)"} onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"} onClick={() => {
                            setSelectedNotifyUser(s);
                            setShowNotifyModal(true);
                          }}>
                                Notify User
                              </button>
                            </li>

                          </ul>
                        </div>

                      </td>
                    </tr>
                  </React.Fragment>)}

              </tbody>
            </table>

                {showStatusModal && <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content" style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>

                            <div className="modal-header">
                              <h5 className="modal-title">Mark {selectedStaff.is_active == 0 ? 'Inactive' : 'Active'}</h5>
                              <button type="button" className="btn-close" onClick={() => setShowStatusModal(false)}></button>
                            </div>

                            <div className="modal-body">
                              <p>Are you sure you want to change this staff status?</p>
                            </div>

                            <div className="modal-footer">
                              <button className="btn btn-secondary" onClick={() => setShowStatusModal(false)}>
                                Cancel
                              </button>

                              <button className="btn btn-warning" onClick={() => {
                    handleToggleStatus(selectedStaff.id);
                    setShowStatusModal(false);
                  }}>
                                Yes, Change
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>}



                    {showUserModal && selectedUser && <>
                        {/* Custom Backdrop */}
                        <div style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.6)",
              zIndex: 1040
            }}></div>

                        {/* Modal */}
                        <div className="d-flex justify-content-center align-items-center" style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 1050
            }}>
                          <div style={{
                width: "100%",
                maxWidth: "420px",
                background: "var(--black)",
                borderRadius: "18px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
              }}>

                            {/* HEADER */}
                            <div style={{
                  background: "var(--black3)",
                  padding: "20px",
                  textAlign: "center",
                  position: "relative"
                }}>
                              <button className="btn-close btn-close-white position-absolute" style={{
                    right: "15px",
                    top: "15px"
                  }} onClick={() => setShowUserModal(false)}></button>

                              {/* Avatar */}
                              <div className="rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center" style={{
                    width: "70px",
                    height: "70px",
                    background: "var(--midGreen)",
                    color: "#fff",
                    fontSize: "26px",
                    fontWeight: "bold"
                  }}>
                                {selectedUser.name?.charAt(0)}
                              </div>

                              <h5 className="mb-0 text-white">{selectedUser.name}</h5>
                              <small style={{
                    color: "var(--grey)"
                  }}>
                                User ID: {selectedUser.user_id}
                              </small><br />
                              <small style={{
                    color: "var(--grey)"
                  }}>
                                Joined On: {formatDate(selectedUser.created_on)}
                              </small>
                            </div>

                            {/* BODY */}
                            <div style={{
                  padding: "20px"
                }}>

                              {/* Email */}
                              <div className="mb-3">
                                <label style={{
                      color: "var(--grey)",
                      fontSize: "13px"
                    }}>
                                  Email
                                </label>
                                <div style={{
                      background: "var(--black2)",
                      padding: "10px",
                      borderRadius: "8px",
                      color: "#fff"
                    }}>
                                  {selectedUser.email || "-"}
                                </div>
                              </div>

                              {/* Phone */}
                              <div className="mb-3">
                                <label style={{
                      color: "var(--grey)",
                      fontSize: "13px"
                    }}>
                                  Phone Number
                                </label>
                                <div style={{
                      background: "var(--black2)",
                      padding: "10px",
                      borderRadius: "8px",
                      color: "#fff"
                    }}>
                                  {selectedUser.mobile || "-"}
                                </div>
                              </div>

                              {/* Address */}
                              <div className="mb-2">
                                <label style={{
                      color: "var(--grey)",
                      fontSize: "13px"
                    }}>
                                  Address
                                </label>
                                <div style={{
                      background: "var(--black2)",
                      padding: "10px",
                      borderRadius: "8px",
                      color: "#fff"
                    }}>
                                  {getAddress(selectedUser.address)}
                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                      </>}


                    {/* {showEmployeeModal && (
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100vw",
                          height: "100dvh",
                          background: "rgba(0,0,0,0.7)",
                          zIndex: 1040,
                          backdropFilter: "blur(3px)",
                        }}
                      >
                     
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100dvh",
                            zIndex: 1050,
                          }}
                        >
                          <div
                            style={{
                              width: "90%",
                              maxWidth: "800px",
                              background: "linear-gradient(145deg, var(--black2), var(--black))",
                              borderRadius: "15px",
                              overflow: "hidden",
                              boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                              border: "1px solid rgba(255,255,255,0.06)",
                            }}
                            className="p-4"
                          >
                                                <div className="modal-header">
                              <h5 className="modal-title text-white">
                                Referal History  of {selectedUserForEmp.name}
                              </h5>
                              <button
                                className="btn-close btn-close-white"
                                onClick={() => setShowEmployeeModal(false)}
                              ></button>
                            </div>
                            
                            <div className="modal-body text-white custom-scrollbar"
                             style={{
                     maxHeight: "70vh",
                     overflowY: "auto",
                     paddingRight: "8px",
                     }}
                            >
                                <p>Total Referrals: {employeeList.length}</p>
                              <p>Total Coins: {totalCoins}</p>
                              <p>Wallet Used: {walletUsed}</p>
                              <p className="text-success">
                                Remaining Wallet: {remainingWallet}
                              </p>
                                <div className="table-responsive">
                                <table className="table text-white text-center">
                                  <thead>
                                    <tr>
                                      <th style={{ background: "var(--black2)", color: "#fff" }} >SN</th>
                                      <th style={{ background: "var(--black2)", color: "#fff" }}>Name</th>
                                      <th style={{ background: "var(--black2)", color: "#fff" }}>Mobile</th>
                                    </tr>
                                  </thead>
                                    <tbody>
                                    {employeeList.map((emp, i) => (
                                      <tr key={i}>
                                        <td style={{ background: "var(--black)", color: "#fff", }}>{i + 1}</td>
                                        <td style={{ background: "var(--black)", color: "#fff", }}>{emp.users_name}</td>
                                        <td style={{ background: "var(--black)", color: "#fff", }}>{emp.users_mobile}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                              </div>
                            </div>
                        </div>
                      </div>
                     )} */}
                    {showEmployeeModal && <>
    {/* Backdrop */}
    <div style={{
              position: "fixed",
              inset: 0,
              width: "100vw",
              height: "100dvh",
              background: "rgba(0,0,0,0.7)",
              backdropFilter: "blur(3px)",
              zIndex: 1040
            }} onClick={() => setShowEmployeeModal(false)} />

    {/* Modal Wrapper */}
    <div className="d-flex justify-content-center align-items-center" style={{
              position: "fixed",
              inset: 0,
              width: "100vw",
              height: "100dvh",
              zIndex: 1050,
              padding: "12px",
              overflowY: "auto",
              WebkitOverflowScrolling: "touch"
            }}>
      <div onClick={e => e.stopPropagation()} style={{
                width: "95%",
                maxWidth: "800px",
                maxHeight: "90dvh",
                background: "linear-gradient(145deg, var(--black2), var(--black))",
                borderRadius: "15px",
                overflow: "hidden",
                boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                border: "1px solid rgba(255,255,255,0.06)"
              }}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center p-3" style={{
                  borderBottom: "1px solid rgba(255,255,255,0.08)"
                }}>
          <h5 className="mb-0 text-white" style={{
                    fontSize: "clamp(16px, 4vw, 20px)",
                    wordBreak: "break-word",
                    paddingRight: "10px"
                  }}>
            Referral History of {selectedUserForEmp?.name}
          </h5>

          <button className="btn-close btn-close-white" onClick={() => setShowEmployeeModal(false)} />
        </div>

        {/* Body */}
        <div className="text-white custom-scrollbar p-3" style={{
                  maxHeight: "calc(90dvh - 80px)",
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch"
                }}>
          <div className="mb-3">
            <p className="mb-1">
              <strong>Total Referrals:</strong> {employeeList.length}
            </p>

            <p className="mb-1">
              <strong>Total Coins:</strong> {totalCoins}
            </p>

            <p className="mb-1">
              <strong>Wallet Used:</strong> {walletUsed}
            </p>

            <p className="text-success mb-0">
              <strong>Remaining Wallet:</strong> {remainingWallet}
            </p>
          </div>

          <div className="table-responsive" style={{
                    WebkitOverflowScrolling: "touch"
                  }}>
            <table className="table text-center align-middle mb-0">
              <thead>
                <tr>
                  <th style={{
                            background: "var(--black2)",
                            color: "#fff",
                            whiteSpace: "nowrap"
                          }}>
                    SN
                  </th>

                  <th style={{
                            background: "var(--black2)",
                            color: "#fff",
                            whiteSpace: "nowrap"
                          }}>
                    Name
                  </th>

                  <th style={{
                            background: "var(--black2)",
                            color: "#fff",
                            whiteSpace: "nowrap"
                          }}>
                    Mobile
                  </th>
                </tr>
              </thead>

              <tbody>
                {employeeList.length > 0 ? employeeList.map((emp, i) => <tr key={i}>
                      <td style={{
                            background: "var(--black)",
                            color: "#fff"
                          }}>
                        {i + 1}
                      </td>

                      <td style={{
                            background: "var(--black)",
                            color: "#fff"
                          }}>
                        {emp.users_name}
                      </td>

                      <td style={{
                            background: "var(--black)",
                            color: "#fff"
                          }}>
                        {emp.users_mobile}
                      </td>
                    </tr>) : <tr>
                    <td colSpan="3" style={{
                            background: "var(--black)",
                            color: "#fff",
                            padding: "20px"
                          }}>
                      No referral data found
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </>}


            {showNotifyModal && selectedNotifyUser && <>
                {/* Backdrop */}
                <div style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100dvh",
              background: "rgba(0,0,0,0.7)",
              zIndex: 1040,
              backdropFilter: "blur(3px)"
            }}></div>

                {/* Modal */}
                <div className="d-flex justify-content-center align-items-center" style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100dvh",
              zIndex: 1050
            }}>
                  <div style={{
                width: "100%",
                maxWidth: "450px",
                background: "linear-gradient(145deg, var(--black2), var(--black))",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                border: "1px solid rgba(255,255,255,0.06)"
              }}>

                    {/* Header */}
                    <div style={{
                  padding: "20px",
                  background: "var(--black3)",
                  position: "relative",
                  textAlign: "center"
                }}>

                      <button className="btn-close btn-close-white position-absolute" style={{
                    right: "15px",
                    top: "15px"
                  }} onClick={() => setShowNotifyModal(false)}></button>

                      <div className="mx-auto mb-3 d-flex align-items-center justify-content-center" style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    background: "rgba(25,135,84,0.15)",
                    border: "2px solid #198754"
                  }}>
                        <FaBell size={28} color="#20c997" />
                      </div>

                      <h4 className="text-white mb-1">
                        Send Notification
                      </h4>

                      <p style={{
                    color: "var(--grey)",
                    marginBottom: 0,
                    fontSize: "14px"
                  }}>
                        User: {selectedNotifyUser.name}
                      </p>

                    </div>

                    {/* Body */}
                    <div style={{
                  padding: "22px"
                }}>

                      <label className="mb-2" style={{
                    color: "#ddd",
                    fontSize: "14px"
                  }}>
                        Notification Message
                      </label>

                      <textarea className="form-control" rows="5" placeholder="Write notification message..." value={notifyMessage} onChange={e => setNotifyMessage(e.target.value)} style={{
                    background: "var(--black2)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    color: "#fff",
                    borderRadius: "12px",
                    padding: "14px"
                  }}></textarea>

                      {/* Footer Buttons */}
                      <div className="d-flex justify-content-end gap-2 mt-4">

                        <button className="btn btn-secondary" onClick={() => setShowNotifyModal(false)}>
                          Cancel
                        </button>

                        <button className="btn btn-success px-4" onClick={handleUserNotification}>
                          <FaBell className="me-2" />
                          Send
                        </button>

                      </div>

                    </div>

                  </div>
                </div>
              </>}

          </div>

        </div>




      </div>
    </div>;
}
export default ManageUser;
